import { render, staticRenderFns } from "./ProjectTongBu.vue?vue&type=template&id=20dd3523&scoped=true&"
import script from "./ProjectTongBu.vue?vue&type=script&lang=js&"
export * from "./ProjectTongBu.vue?vue&type=script&lang=js&"
import style0 from "./ProjectTongBu.vue?vue&type=style&index=0&id=20dd3523&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20dd3523",
  null
  
)

export default component.exports